// extracted by mini-css-extract-plugin
export default {"right-arrow-desktop":"style_right-arrow-desktop__IzclA","left-arrow-desktop":"style_left-arrow-desktop__3y2I2"};